<template>
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.5 0.5C4.9775 0.5 0.5 4.9775 0.5 10.5C0.5 16.0225 4.9775 20.5 10.5 20.5C16.0225 20.5 20.5 16.0225 20.5 10.5C20.5 4.9775 16.0225 0.5 10.5 0.5ZM9.66666 13.8333C9.66666 14.2933 9.29333 14.6667 8.83333 14.6667C8.37333 14.6667 8 14.2933 8 13.8333V7.16666C8 6.70666 8.37333 6.33333 8.83333 6.33333C9.29333 6.33333 9.66666 6.70666 9.66666 7.16666V13.8333ZM13 13.8333C13 14.2933 12.6267 14.6667 12.1667 14.6667C11.7067 14.6667 11.3333 14.2933 11.3333 13.8333V7.16666C11.3333 6.70666 11.7067 6.33333 12.1667 6.33333C12.6267 6.33333 13 6.70666 13 7.16666V13.8333Z"
            fill="#394E5B"
        />
    </svg>
</template>
